import type { TranslateDictionary } from './en.js';

export const De: TranslateDictionary = {
  'Drop a video file here to upload': 'Legen Sie hier eine Videodatei zum Hochladen ab',
  or: 'oder',
  'Upload complete!': 'Upload abgeschlossen!',
  Retry: 'Wiederholen',
  'Pausing...': 'Pausiere...',
  Resume: 'Fortsetzen',
  Pause: 'Pausieren',
  'Upload a video': 'Video hochladen',
  'No url or endpoint specified - cannot handle upload':
    'Keine URL oder Endpunkt angegeben - Upload kann nicht verarbeitet werden',
};
